module.exports = __webpack_public_path__ + "img/minus.83697c5f.svg";